module.exports = __webpack_public_path__ + "img/elantra3.e10e0d26.jpeg";